/* eslint-disable max-len */
import { ObjectRuleSet } from '@Core/services/proprietary/object-rule/object-rule.types';

export const TaskActionRules: ObjectRuleSet = {
    source: 'Core.TaskAction.Base',
    defaultEvents: 'Create;Complete;Skip',
    objects: {
        Task: {
            stateObject: 'Task',
            itemIDField: 'Task_ID',
            fields: {
                $Record: {
                    desc: "'Task'"
                },
                Protect_Late_Ind: {
                    rules: [{ rule: "disableIf([$This.Task_ID] > 0 && [$This.Saved_Protect_Late_Ind] == 'Y')" }]
                },
                Late_Date: { rules: [{ rule: "disableIf([$This.Protect_Late_Ind]=='Y')" }] },
                Late_Date_Quick_Select: { rules: [{ rule: "disableIf([$This.Protect_Late_Ind]=='Y')" }] },
                Task_Note: {
                    rules: [
                        {
                            rule: "requiredIf([$This.Note_Required_Ind]=='Y')",
                            events: 'Complete',
                            message: 'A Note is Required before this task can be completed'
                        }
                    ]
                },
                'Route.Assign_Note': { rules: [{ rule: "disableIf([$This.Route.Assign_To.Assign_To_Type]=='AUTOASSIST')" }] },
                'Route.Notify_Immediate_Ind': {
                    rules: [{ rule: "disableIf([$This.Route.Assign_To.Assign_To_Type]!='USER')" }]
                },
                'Route.Notify_Include_Document_Ind': {
                    rules: [{ rule: "disableIf(!([$This.Route.Notify_Immediate_Ind]=='Y' && [$This.Task_Doc_Count] > '1'))" }]
                },
                Assigned_To: { rules: [{ rule: 'disable' }] },
                Task_Object: { rules: [{ rule: 'disable' }] },
                Task_Status: { rules: [{ rule: 'disable' }] },
                Unattend_Post_Ind: {
                    rules: [
                        {
                            rule: "validIf(([$This.Task_Object.Object_Code] != 'INVOICE') || ([$This.Route.Assign_To.Assign_To_Type] != 'AUTOASSIST') || ([$This.Route.Assign_To.Assign_To_Type]=='AUTOASSIST' && [$This.Unattend_Post_Ind]=='Y') || ([$This.Route.Assign_To.Assign_To_Type]=='AUTOASSIST' && [$This.Unattend_Post_Ind]=='N' && [$This.Unattend_Send_Ind]=='Y'))",
                            message: 'At least one routing option needs to be selected'
                        }
                    ]
                },
                Unattend_Complete_Ind: {
                    rules: [
                        {
                            rule: "disableIf([$This.Task_Object.Object_Code]=='INVOICE' && [$This.Unattend_Post_Ind]=='N' && [$This.Unattend_Send_Ind]=='N')"
                        }
                    ]
                }
            }
        },
        Project: {
            stateObject: 'Project',
            itemIDField: 'Session_ID',
            variables: {},
            fields: {
                $Record: {
                    desc: "'Project'"
                }
            }
        }
    }
};
